import { z } from "zod";

export const batchLicenseChangeSchema = z.discriminatedUnion("kind", [
	z.object({ kind: z.literal("seat.assign"), userId: z.string().uuid() }),
	z.object({ kind: z.literal("seat.revoke"), userId: z.string().uuid() }),
	z.object({
		kind: z.literal("tool.assign"),
		userId: z.string().uuid(),
		featureName: z.string().min(1),
	}),
	z.object({
		kind: z.literal("tool.revoke"),
		userId: z.string().uuid(),
		featureName: z.string().min(1),
	}),
	z.object({
		kind: z.literal("invitation.seat.assign"),
		invitationId: z.string().uuid(),
	}),
	z.object({
		kind: z.literal("invitation.seat.revoke"),
		invitationId: z.string().uuid(),
	}),
	z.object({
		kind: z.literal("invitation.tool.assign"),
		invitationId: z.string().uuid(),
		featureName: z.string().min(1),
	}),
	z.object({
		kind: z.literal("invitation.tool.revoke"),
		invitationId: z.string().uuid(),
		featureName: z.string().min(1),
	}),
]);

export const batchLicenseChangesSchema = z.array(batchLicenseChangeSchema);

export type BatchLicenseChange = z.infer<typeof batchLicenseChangeSchema>;
